/* eslint-disable no-restricted-syntax */
import React from 'react';
import InputMask from 'react-input-mask';
import TextField from '@material-ui/core/TextField';

const vinMask = Array(17)
  .fill('*')
  .join('');

const VINInput = ({ input, meta, label, ...rest }) => (
  <InputMask
    {...input}
    {...rest}
    mask={vinMask}
    onChange={(event) => input.onChange(event.target.value.toUpperCase())}
  >
    {() => (
      <TextField
        variant="filled"
        fullWidth
        error={!!(meta.error && meta.touched)}
        label={label}
        helperText={meta.touched && meta.error}
      />
    )}
  </InputMask>
);

export default VINInput;
